import { render, staticRenderFns } from "./Infor.vue?vue&type=template&id=007984ef&"
import script from "./Infor.vue?vue&type=script&lang=js&"
export * from "./Infor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports